import { type RefObject, useLayoutEffect, useState } from "react"

export const useIsInputAutofilled = (
    containerRef: RefObject<HTMLDivElement | null>,
): boolean => {
    const [isAutoFilled, setIsAutoFilled] = useState<boolean>(false)

    useLayoutEffect(() => {
        // https://github.com/facebook/react/issues/1159#issuecomment-1025423604
        // This is a workaround to handle floating label and autoFilled input
        // The field can be prefilled on the very first page loading by the browser
        // By the security reason browser limits access to the field value from JS level
        // and the value becomes available only after first user interaction with the page
        const checkAutoFill = () => {
            if (!containerRef.current) {
                return
            }

            try {
                setIsAutoFilled(
                    containerRef.current
                        .getElementsByTagName("input")?.[0]
                        ?.matches("*:-webkit-autofill"),
                )
            } catch (e) {}
        }

        const timeOutIdInitial = setTimeout(checkAutoFill, 1000)
        const timeOutIdExtended = setTimeout(checkAutoFill, 3 * 1000)

        return () => {
            try {
                if (timeOutIdInitial) {
                    clearTimeout(timeOutIdInitial)
                }

                if (timeOutIdExtended) {
                    clearTimeout(timeOutIdExtended)
                }
            } catch (e) {}
        }
    }, [])

    return isAutoFilled
}
